import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { ProtoDriverDto } from '../../dtos/proto-driver.dto';
import { updateProtoDriverSchema } from '../schemas/update-proto-driver.schema';

/**
 * Validates driver record.
 * @param driver - The driver record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const isValidProtoDriver = (
	driver: ProtoDriverDto,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check
	if (!driver) throw new Error('Driver is required');

	// Validate
	const { error } = updateProtoDriverSchema().validate(driver, {
		abortEarly,
	});

	// Check
	if (error) {
		return {
			isValid: false,
			errors: error.details?.map((e) => e.message),
		};
	}

	// Return
	return { isValid: true };
};
